module.exports = __webpack_public_path__ + "static/media/bereavement.5998fa2e.svg";